module.exports = __webpack_public_path__ + "img/pzlx5@3x.a1e30fec.png";